<template>
    <b-row>
      <b-col md="6">
        <dl class="row">
          <dt class="col-sm-3">AsuriteId</dt>
          <dd class="col-sm-9">{{student.asuriteId}}</dd>
          <dt class="col-sm-3">College</dt>
          <dd class="col-sm-9">{{student.college}}</dd>
          <dt class="col-sm-3">Major</dt>
          <dd class="col-sm-9">{{student.major}}</dd>
        </dl>
      </b-col>
      <b-col md="6">
        <dl class="row">
          <dt class="col-sm-3">Credit Hours</dt>
          <dd class="col-sm-9">{{student.totalCumulative}}</dd>
          <dt class="col-sm-3">GPA</dt>
          <dd class="col-sm-9">{{student.cumulativeGPA}}</dd>
        </dl>
      </b-col>
    </b-row>
</template>

<script>
import { mapState } from "vuex";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars

export default {
  data() {
    return {};
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },

  props: {
    student: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
</style>
